import { EditableStatus, ListStatus } from '@/store/types';
import Distributor from './distributor';

export enum DistributorsActions {
  LOAD_LIST = 'LOAD_LIST',
  LOAD_DISTRIBUTOR = 'LOAD_DISTRIBUTOR',
  UPDATE_EDITABLE = 'UPDATE_EDITABLE',
  SAVE_EDITABLE = 'SAVE_EDITABLE',
  DELETE = 'DELETE',
  RESTORE = 'RESTORE',
}

export enum DistributorsMutations {
  SET_LIST = 'SET_LIST',
  SET_LIST_STATUS = 'SET_LIST_STATUS',
  SET_DISTRIBUTOR = 'SET_DISTRIBUTOR',
  UPDATE_INITIAL_EDITABLE = 'UPDATE_INITIAL_EDITABLE',
  UPDATE_EDITABLE = 'UPDATE_EDITABLE',
  SET_EDITABLE_STATUS = 'SET_EDITABLE_STATUS',
}

export interface DistributorsState {
  list: Distributor[];
  listStatus: ListStatus;
  editableStatus: EditableStatus;
  currentDistributor?: Distributor;
  editableDistributor?: Distributor;
}
